// ================================================================================
// ECOMSIMPLY - HOOK REACT API CLIENT
// Hook pour utiliser le client API centralisé
// ================================================================================

import { useMemo } from 'react';
import apiClient from '../lib/apiClient';

export const useApiClient = () => {
  return useMemo(() => apiClient, []);
};

export default useApiClient;